import React from 'react';
import { motion } from 'framer-motion';
import { PORTFOLIO_IMAGES } from '../data/mockData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiInstagram } = FiIcons;

const Portfolio = () => {
  const { t } = useLanguage();

  return (
    <div className="pt-32 pb-20 min-h-screen">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }} 
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <h1 className="font-serif text-5xl mb-6">{t('portfolio.title')}</h1>
          <a href="#" className="inline-flex items-center gap-2 text-sm uppercase tracking-widest hover:text-accent transition-colors font-medium">
            <SafeIcon icon={FiInstagram} /> {t('portfolio.follow')}
          </a>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
          {PORTFOLIO_IMAGES.map((img, index) => (
            <motion.div 
              key={index} 
              initial={{ opacity: 0, scale: 0.95 }} 
              whileInView={{ opacity: 1, scale: 1 }} 
              viewport={{ once: true }} 
              transition={{ delay: index * 0.1, duration: 0.5 }} 
              className="aspect-[4/5] overflow-hidden group relative cursor-pointer"
            >
              <img src={img} alt={t('portfolio.imageAlt')} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
